var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6339 10.3661C20.122 10.8543 20.122 11.6457 19.6339 12.1339L12.1339 19.6339C11.6457 20.122 10.8543 20.122 10.3661 19.6339C9.87796 19.1457 9.87796 18.3543 10.3661 17.8661L17.8661 10.3661C18.3543 9.87796 19.1457 9.87796 19.6339 10.3661Z",
    fill: "url(#paint0_linear_1_190)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.125C20 19.1605 19.1605 20 18.125 20C17.0895 20 16.25 19.1605 16.25 18.125C16.25 17.0895 17.0895 16.25 18.125 16.25C19.1605 16.25 20 17.0895 20 18.125Z",
    fill: "url(#paint1_linear_1_190)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.875C13.75 12.9105 12.9105 13.75 11.875 13.75C10.8395 13.75 10 12.9105 10 11.875C10 10.8395 10.8395 10 11.875 10C12.9105 10 13.75 10.8395 13.75 11.875Z",
    fill: "url(#paint2_linear_1_190)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6686 3.80051C13.5661 2.10507 16.4342 2.10507 18.3316 3.80051L18.6337 4.07045C19.056 4.44774 19.5938 4.67051 20.1591 4.7023L20.5636 4.72504C23.1042 4.86787 25.1322 6.89594 25.2751 9.43648L25.2978 9.84098C25.3296 10.4063 25.5524 10.9442 25.9297 11.3664L26.1996 11.6685C27.895 13.5659 27.895 16.4341 26.1996 18.3315L25.9297 18.6336C25.5524 19.0558 25.3296 19.5936 25.2978 20.159L25.2751 20.5635C25.1322 23.104 23.1042 25.1321 20.5636 25.2749L20.1591 25.2977C19.5938 25.3295 19.056 25.5522 18.6337 25.9295L18.3316 26.1995C16.4342 27.8949 13.5661 27.8949 11.6686 26.1995L11.3665 25.9295C10.9443 25.5522 10.4065 25.3295 9.8411 25.2977L9.43661 25.2749C6.89606 25.1321 4.86799 23.104 4.72516 20.5635L4.70242 20.159C4.67063 19.5936 4.44786 19.0558 4.07057 18.6336L3.80063 18.3315C2.10519 16.4341 2.10519 13.5659 3.80063 11.6685L4.07057 11.3664C4.44786 10.9442 4.67063 10.4063 4.70242 9.84098L4.72516 9.43649C4.86799 6.89594 6.89606 4.86787 9.43661 4.72504L9.8411 4.7023C10.4065 4.67051 10.9443 4.44774 11.3665 4.07045L11.6686 3.80051ZM16.6659 5.66472C15.7171 4.817 14.2831 4.817 13.3344 5.66472L13.0323 5.93466C12.1878 6.68924 11.1121 7.13478 9.98144 7.19835L9.57694 7.2211C8.30667 7.29251 7.29263 8.30655 7.22122 9.57682L7.19848 9.98131C7.1349 11.112 6.68936 12.1877 5.93478 13.0321L5.66484 13.3342C4.81712 14.283 4.81712 15.717 5.66484 16.6657L5.93478 16.9678C6.68936 17.8123 7.1349 18.888 7.19848 20.0187L7.22122 20.4232C7.29263 21.6934 8.30667 22.7075 9.57694 22.7789L9.98144 22.8016C11.1121 22.8652 12.1878 23.3107 13.0323 24.0653L13.3344 24.3353C14.2831 25.183 15.7171 25.183 16.6659 24.3353L16.968 24.0653C17.8124 23.3107 18.8881 22.8652 20.0188 22.8016L20.4233 22.7789C21.6936 22.7075 22.7076 21.6934 22.779 20.4232L22.8018 20.0187C22.8653 18.888 23.3109 17.8123 24.0654 16.9678L24.3354 16.6657C25.1831 15.717 25.1831 14.283 24.3354 13.3342L24.0654 13.0321C23.3109 12.1877 22.8653 11.112 22.8018 9.98132L22.779 9.57682C22.7076 8.30655 21.6936 7.29251 20.4233 7.2211L20.0188 7.19835C18.8881 7.13478 17.8124 6.68924 16.968 5.93466L16.6659 5.66472Z",
    fill: "url(#paint3_linear_1_190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_190",
    x1: 10.1682,
    y1: 10,
    x2: 20.2143,
    y2: 10.2202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_190",
    x1: 16.3131,
    y1: 16.25,
    x2: 20.0804,
    y2: 16.3326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_190",
    x1: 10.0631,
    y1: 10,
    x2: 13.8304,
    y2: 10.0826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_190",
    x1: 2.94857,
    y1: 2.52892,
    x2: 28.0058,
    y2: 3.07807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffers);
export default __webpack_public_path__ + "static/media/icon_offers.5b44e1e440dc875eebd4526b8a27b6ab.svg";
export { ForwardRef as ReactComponent };